import { div } from 'framer-motion/client'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
import banner from "../../../assets/kangaroo/AboutBanner.png"
import SectionContainer from '../../../Homepage/SectionContainer'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import "../../CountryPage/country.css"
import guideImg from "../../../assets/kangaroo/guided.png"
import memberImg from "../../../assets/kangaroo/members.png"
import partnerImg from "../../../assets/kangaroo/partners.png"
import graduateImg from "../../../assets/kangaroo/graduates.png"
import officeImg from "../../../assets/kangaroo/office.png"
import experienceImg from "../../../assets/kangaroo/experience.png"
import "../About.css"
import house from "../../../assets/kangaroo/PurpleHouse2Web.webp"
import { useLocation } from 'react-router-dom'
import PageService from '../../../services/PageService'
import { imageBaseApi } from '../../../services/imageBaseApi'
const AboutLanding = () => {
  const data = {
    guided: {
      number: "20,000+",
      desc: "STUDENTS GUIDED",
      color: "#7e1790",
      img: guideImg
    },
    members: {
      number: "100+",
      desc: "TEAM MEMBERS",
      color: "#687c86",
      img: memberImg
    },
    parterns: {
      number: "200+",
      desc: "GLOBAL PARTNER <br/> INSTITUTIONS",
      color: "#1900da",
      img: partnerImg
    },
    graduates: {
      number: "8,000+",
      desc: "TEST PREPARATION <br/> GRADUATES",
      color: "#d70a84",
      img: graduateImg
    },
    offices: {
      number: "14+",
      desc: "OFFICES ACROSS NEPAL & AUSTRALIA",
      color: "#ff4d1d",
      img: officeImg
    },
    experience: {
      number: "19+",
      desc: "YEARS OF EXPERIENCE",
      color: "#7a0708",
      img: experienceImg
    },

  }

  const stats = Object.values(data)

  const location = useLocation();
  const path = location.pathname.split("/").filter(Boolean).pop();




  const [detailData, setDetailData] = useState()
  const fetchDetail = async () => {
    try {
      const response = await PageService.getbySlug(path);
      setDetailData(response)
    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    fetchDetail()
  }, [location])
  return (
    <div>
      <div className='about-hero-banner' style={{ "--banner-img": `url(${imageBaseApi + detailData?.featuredMedia?.url})`, marginBottom: "5.5rem" }}>
        <SectionContainer >
          <BreadCrumb items={[
            { title: "HOME", link: "/" },
            { title: "WHO WE ARE" },

          ]} instituition={true} />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className='font-level-4'>WHO WE ARE</h1>
          </div>
        </SectionContainer>

      </div>
      <SectionContainer>

        <Container>
          <Row>
            <Col> <p className='country-paragraph-text' >Kangaroo Education & Visa Services (KEVS) is the onshore arm of the Kangaroo education ecosystem, dedicated to supporting international students and graduates after they arrive in Australia. Our role is to provide reliable, compliant, and practical support that helps students continue their studies, manage visa responsibilities, and navigate life onshore with confidence. <br /> <br />

              KEVS exists to ensure continuity. While many students receive guidance before arriving in Australia, challenges often arise during their studies or after graduation - when visa conditions, enrolment requirements, health cover, or financial obligations must be carefully managed. KEVS bridges this gap by offering structured, student-first support focused on clarity, compliance, and informed decision-making. <br /> <br />

              With physical offices in Sydney, Adelaide, and Hobart, our team works closely with students across Australia, providing accessible and personalised assistance. We support students through key onshore stages, including education progression, visa transitions, health cover requirements, and financial compliance, ensuring that no step is taken without proper understanding. <br /> <br />

            </p></Col>
          </Row>
          <Row className='d-flex  align-items-start mt-5'>
            <Col lg={6} sm={12} ><img src={house} className=' whoweare-img' alt="" /></Col>
            <Col lg={6} sm={12}> <p className='country-paragraph-text align-items-center'>Our approach is grounded in accuracy and responsibility. Every student’s situation is different, and onshore decisions often carry direct compliance implications. That is why we take time to understand each student’s current visa status, education pathway, and future plans before offering guidance. Our aim is not to rush outcomes, but to support students in making well-informed choices that protect their status and future opportunities in Australia. <br /> <br />

              KEVS works in alignment with Australian regulations and institutional requirements, providing guidance that is transparent, realistic, and ethical. We do not promise outcomes - instead, we focus on helping students understand their options, obligations, and next steps clearly. <br /> <br />

              </p></Col>
          </Row>
          <Row >
            <Col style={{ marginTop: "3.9rem", marginBottom: "5.3rem" }}>
              <p className='country-paragraph-text m-0 '>Above all, KEVS is committed to being a trusted onshore support partner. Whether a student needs help continuing their studies, navigating visa conditions, arranging health cover, or understanding tax responsibilities, our team is here to provide dependable support throughout their journey in Australia. 
                <br /> <br />
                <span className='font-level-8'>Vision</span> <br />
                To become a synonym for the <span className='fw-bold'>education–migration ecosystem.</span>
                <br /> <br />
                <span className='font-level-8'>Mission</span> <br />
                To empower study-abroad aspirants by providing <span className='fw-bold'>authentic and genuine counseling, effective test preparation classes, and reliable support services.</span>
                <br /> <br />
                <span className='font-level-8'>Values</span> <br />
                Integrity, Commitment, and Trust.
                <br /> <br />
                <span className='font-level-8'>Goal</span> <br />
                <span className='fw-bold'>Grow. Accelerate. Excel.</span>
                <br /> <br />
                <span className='font-level-8'>Objective</span> <br />
                We shall <span className='fw-bold'>GROW </span>every day by challenging ourselves, not others; <span className='fw-bold'>ACCELERATE </span>by competing with our own past performance, not that of others; and <span className='fw-bold'>EXCEL </span>by outperforming our own expectations rather than measuring ourselves against others.
                This philosophy drives our continuous improvement and reinforces our commitment to delivering ethical, student-centric, and future-focused guidance.
                <br /> <br />
                <span className='font-level-8'>Our Commitment</span> <br />
                At <span className='fw-bold'>Kangaroo Education & Visa Services (KEVS)</span>, we are professionally committed to supporting international students <span className='fw-bold'>after they arrive in Australia</span>. With a dedicated and experienced onshore team, we help students navigate education progression, visa responsibilities, health cover requirements, and financial compliance with clarity and care. <br />
Our commitment is rooted in honesty and responsibility. We focus on helping students understand their obligations, explore realistic options, and make informed decisions that protect their status and future opportunities in Australia.
KEVS exists to bridge the gap between <span className='fw-bold'>arrival and long-term success</span>, ensuring that students are not only informed, but supported at every stage of their onshore journey.</p></Col>
          </Row>
          <Row style={{ marginBottom: "22.6rem" }}>
            {stats.map((item, index) => (
              <Col
                key={index}
                lg={4}
                sm={12}
                className="mb-4 d-flex align-items-stretch"
                style={{ height: "330px" }}
              >
                <div
                  className="stat-tile gap-4 border rounded-5 p-3 w-100 h-100 d-flex flex-column justify-content-end pb-4 ps-4"
                  style={{
                    backgroundColor: item.color,
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow = "0 10px 30px rgba(0, 0, 0, 0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <img
                    src={item.img}
                    fluid
                    className="tile-img"
                    alt=""
                    style={{
                      transition: "transform 0.3s ease"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  />
                  <div>
                    <h2 className="about-tile-heading ">{item.number}</h2>
                    <p
                      className="about-tile-subtext mt-4 lh-1"
                      dangerouslySetInnerHTML={{ __html: item.desc }}
                    ></p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

        </Container>
      </SectionContainer>

    </div>
  )
}

export default AboutLanding
